module.exports = __webpack_public_path__ + "static/media/ice24.52eddf70.webp";